import { render, staticRenderFns } from "./ConfirmarVinculacion.vue?vue&type=template&id=ec0c3e62"
import script from "./ConfirmarVinculacion.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmarVinculacion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports